import { useMutation } from '@tanstack/react-query';
import { apiRoutes } from 'constants/apiKeys';
import baseFetcher, { FetcherError } from 'shared/helpers/baseFetcher';

interface LoginData {
  email: string;
}

export function useLoginMutation() {
  return useMutation<void, FetcherError, LoginData>({
    mutationFn: (data) =>
      baseFetcher(apiRoutes.login(), { method: 'POST', data }),
  });
}

interface LoginTokenData {
  email: string;
  login_code: string;
}

interface LoginTokenResponse {
  token: string;
}

export function useLoginTokenMutation() {
  return useMutation<LoginTokenResponse, FetcherError, LoginTokenData>({
    mutationFn: (data) =>
      baseFetcher(apiRoutes.loginToken(), { method: 'POST', data }),
    onSuccess: (data) => {
      localStorage.setItem(
        'authorization',
        JSON.stringify({ token: data.token })
      );
      window.location.replace('/');
    },
  });
}

export function useLogoutMutation() {
  return useMutation({
    mutationFn: () => baseFetcher(apiRoutes.logout(), { method: 'POST' }),
    onSettled: () => {
      localStorage.removeItem('authorization');
      window.location.reload();
    },
  });
}

export function useLogoutAllMutation() {
  return useMutation({
    mutationFn: () => baseFetcher(apiRoutes.logoutAll(), { method: 'POST' }),
    onSettled: () => {
      localStorage.removeItem('authorization');
      window.location.reload();
    },
  });
}
